import { API_BASE } from '../api/client'
import { env } from '../config/env'
import './backendBadge.css'

/**
 * The API host this page load talks to — #449. Every build except production.
 *
 * Reads `API_BASE`, the value the client was constructed with, rather than
 * re-resolving the override: the badge must name where requests GO, and a
 * second resolution could disagree with the first and the badge would never
 * know. It says "override" only when that host differs from the build's own
 * `VITE_API_BASE`.
 *
 * Rendered by `TopBar` behind `import.meta.env.MODE !== 'production'`, so a
 * production build drops this module; `backendOverride.build.test.ts` looks
 * for its class in the bundle.
 *
 * Text, not a link: it reports, and Settings › Developer is where it changes.
 * `--ink2` at caption size is what `.topbar__meta` already sets on this same
 * bar, so the contrast is the bar's existing, measured pairing.
 */
function hostOf(base: string): string {
  try {
    return new URL(base).host
  } catch {
    return base
  }
}

export function BackendBadge() {
  const overridden = API_BASE !== env.apiBase
  return (
    <p className="chrome-badge backend-badge" data-testid="backend-badge">
      <span className="backend-badge__label">API</span>{' '}
      <span className="backend-badge__host">{hostOf(API_BASE)}</span>
      {overridden && (
        <>
          {' '}
          <span className="backend-badge__override">override</span>
        </>
      )}
    </p>
  )
}
